const AddJob = () => {
  return (
    <div>AddJob</div>
  );
}

export default AddJob;